import {
  CalendarDate,
  CalendarDateTime,
  DateValue,
  fromAbsolute,
  toZoned,
  ZonedDateTime,
} from '@internationalized/date';

import { TimeZone } from './timezones';

export const convertCalendarDateToZonedAtMidnight = (value: CalendarDate, timeZone: TimeZone) => {
  const date = new CalendarDateTime(value.year, value.month, value.day, 0, 0, 0, 0);
  return convertDateTimeToZoned(date, timeZone);
};

export const convertDateTimeToZoned = (value: CalendarDateTime, timeZone: TimeZone) => {
  return toZoned(value, timeZone);
};

export const convertNativeDateToZoned = (value: Date, timeZone: TimeZone) => {
  return fromAbsolute(value.getTime(), timeZone);
};

export const updateTimeZoneOnZonedDateTime = (value: ZonedDateTime, timeZone: TimeZone) => {
  const { year, month, day, hour, minute, second, millisecond } = value;
  const date = new CalendarDateTime(year, month, day, hour, minute, second, millisecond);

  return toZoned(date, timeZone);
};

export const formatAnyDateTypeToZonedDateTime = (
  date: DateValue | Date | null,
  timeZone: TimeZone,
): DateValue | null => {
  try {
    if (!date) return null;

    const isZonedDateTime = date instanceof ZonedDateTime;
    if (isZonedDateTime) return date;

    const isCalendarDate = date instanceof CalendarDate;
    if (isCalendarDate) {
      return convertCalendarDateToZonedAtMidnight(date, timeZone);
    }

    const isNativeDate = date instanceof Date;
    // Basically, if it's a native date or a string
    if (isNativeDate || !isZonedDateTime || !isCalendarDate) {
      return convertNativeDateToZoned(new Date(date as any), timeZone);
    }

    return convertDateTimeToZoned(date, timeZone);
  } catch (error) {
    return null;
  }
};
